import linePlannerApi from '../../api/linePlanner';
import { HandoverReportConfig } from '../../components/Handover';

export const linePlannerHandoverConfig: HandoverReportConfig = {
    title: "Line Planner Handover Reports",
    dialogTitle: "Line Planner Handover",
    editGroup: "Line Planner Handover Edit",
    employeeLabel: "Shift leaders",
    // No filter bar: it was removed from Line Planner on purpose (MT-854). Only
    // Maintenance Control keeps one.
    showFilters: false,
    showPdfExport: true,
    showEmailReport: true,
    emailRecipientLabel: "MLIcelandairITSLinePlanning@icelandair.is",
    api: linePlannerApi,
};
